import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import TablePlaceholder from "../../Utils/TablePlaceholder";
import Topnav from "../others/Topnav";
import {
  getAllPartner,
  saveSelectedPartner,
  getSelectedPartner,
  deletePartner,
} from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";
import MoreActionButton from "../../components/patient/utils/MoreActionButton";

const PartnersReport = ({ noTopNav }) => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");
  const { toast } = useContext(ToastContext);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handlePatientInfo = () => {
    console.log("clicked");
    navigate("/pinfo");
  };

  const [report, setReport] = useState(null);

  const filteredItems = report
    ?.filter((item) => {
      if (filter === "all") {
        return report;
      } else if (filter === "inActive") {
        return report?.map((item) => item.status !== "active");
      }
    })
    .slice(0, 9);

  const getLocalData = async () => {
    localStorage.setItem("apptEdit", "false");
    await getAllPartner().then((resp) => {
      setReport(resp);
      console.log({ resp });
    });
  };
  const handleChildAction = async (mode, details) => {
    if (mode === "view") {
      try {
        localStorage.setItem("apptEdit", true);
        await saveSelectedPartner(details).then((resp) => {
          navigate("/partners/new-partner?mode=summary");
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "edit") {
      try {
        await saveSelectedPartner(details).then((resp) => {
          localStorage.setItem("apptEdit", true);
          navigate("/partners/new-partner?mode=edit");
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "delete") {
      try {
        setShowDeleteDialog(true);
        setSelectedRecord(details);
      } catch (error) {
        console.log({ error });
      }
    }
  };
  const handleAptDelete = async () => {
    if (selectedRecord) {
      await deletePartner(selectedRecord.localID).then((resp) => {
        getLocalData();
        toast.success("Record deleted successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        setShowDeleteDialog(false);
      });
    } else {
      toast.error("Something seems wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const toggleDropdown = (itemId) => {
    setReport((prevReport) =>
      prevReport.map((item) => {
        if (item.id === itemId) {
          return {
            ...item,
            isOpen: !item.isOpen,
          };
        }
        return {
          ...item,
          isOpen: false, // Close dropdown for other items
        };
      })
    );
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    getLocalData();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setReport((prevReport) =>
          prevReport.map((item) => ({
            ...item,
            isOpen: false,
          }))
        );
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {noTopNav ?? <Topnav />}

      {showDeleteDialog && (
        <dialog>
          <div className="w-[300px] bg-white rounded-md p-8 border">
            <p className="text-center mb-6">
              Are you sure you want to delete this partner?
            </p>
            <div className="flex justify-between">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleAptDelete();
                }}
                className="rounded-md text-white bg-primary p-2"
              >
                Confirm
              </button>
              <button
                autoFocus
                className="p-2 border rounded border-red-400"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDeleteDialog(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </dialog>
      )}
      <div className="report">
        <div className="report_header">
          <div className="button">
            <button
              className={filter === "all" ? "active" : ""}
              onClick={() => setFilter("all")}
            >
              All Partners
            </button>
            <button
              className={filter === "Dispensed" ? "active" : ""}
              onClick={() => setFilter("Dispensed")}
            >
              Upcoming Partners
            </button>
            <button
              className={filter === "Expired" ? "active" : ""}
              onClick={() => setFilter("Expired")}
            >
              Completed Partners
            </button>
          </div>
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 7H21"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 12H18"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M10 17H14"
                stroke="#009FE3"
                strokeWidth="1.5"
                stroke-inecap="round"
              />
            </svg>
            Filter
          </button>
        </div>

        <div className="report_table">
          {filteredItems?.length >= 0 ? (
            <table>
              <thead>
                <tr>
                  <th className="tag_1">
                    {/* <input type="checkbox" name="Prescription ID" id="pre_id" />{" "} */}
                    <span>ID</span>
                  </th>
                  <th className="tag_2">
                    <span>Partner Name</span>
                  </th>
                  <th>Date </th>
                  <th>Partner Type</th>
                  <th>Last Activity</th>
                  <th className="status_head">
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredItems?.map((item, index) => (
                  <tr
                    className={`${item.status}`}
                    key={`${item.localID + index}-partners `}
                  >
                    <td>
                      {/* {" #"} */}
                      <span className="tag">
                        {/* <input type="checkbox" name="Prescription ID" id="pre_id" /> */}
                        #{index + 1}
                      </span>
                    </td>
                    <td className="capitalize">{item.partnerName}</td>
                    <td>{item.joinedDate}</td>
                    <td className="capitalize">{item?.partnerType}</td>
                    <td>{item.joinedDate}</td>
                    <td className="status">
                      <span className={`stats ${item.status}`}>
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <div ref={dropdownRef} className="dot">
                        <MoreActionButton
                          onAction={handleChildAction}
                          details={item}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <TablePlaceholder lost="You have no previous Partners, create a new parners through the Partner manager dropdown." />
          )}
        </div>
      </div>
    </>
  );
};

export default PartnersReport;
